class GccApiUnauthorizedError extends Error {
  constructor(shouldLogout = false) {
    super(shouldLogout ? 'GccApiClient: Unauthorized (Will perform Logout)' : 'GccApiClient: Unauthorized');
    this.shouldLogout = shouldLogout;
  }
}

export default GccApiUnauthorizedError;
